import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const market = {
  namespaced: true,
  state: {
      markets: []
  },
  getters,
  mutations,
  actions
};
